import { fetchApi } from '../api/digitalVault';
import { parseFiles } from '../utils';
export default async (uri, logger) => {
    const urlParams = new URLSearchParams([['uri', uri]]);
    const res = await fetchApi({}, `file?${urlParams.toString()}`, {}, true, logger);
    return parseFiles(res);
};
